module.exports = __webpack_public_path__ + "img/lotto-6-45-mobile.8cb48c87.png";